export default __webpack_public_path__ + "static/media/event-icon.b48c40b5.svg";